import { useState } from "react";

type Anecdote = {
  tag: string;
  tagColor: string;
  title: string;
  story: string;
  emoji: string;
};

const DATA: Anecdote[] = [
  {
    tag: "开场白翻车",
    tagColor: "bg-orange-100 text-orange-700",
    title: "喊错了名字还坚持说完",
    story:
      "小哥为了显得熟络，上来就喊人家“小雨”，结果对方叫“小宇”，他愣是把后半句情话也对着错误的人讲完了。",
    emoji: "😅",
  },
  {
    tag: "时机翻车",
    tagColor: "bg-rose-100 text-rose-700",
    title: "在对方赶末班车时开聊",
    story:
      "看见心动的人气喘吁吁冲向末班车，他火速上前要微信，对方头也没回留下一句“下一班可以”，当场石化。",
    emoji: "🚇",
  },
  {
    tag: "对象翻车",
    tagColor: "bg-teal-100 text-teal-700",
    title: "拍肩膀认错成闺蜜",
    story:
      "隔着人群锁定目标，兴奋地拍肩回头才发现是人家闺蜜，真正的目标就在旁边憋笑，三人同时沉默。",
    emoji: "🙈",
  },
  {
    tag: "道具翻车",
    tagColor: "bg-amber-100 text-amber-700",
    title: "准备的惊喜礼物忘带",
    story:
      "前夜备好的一大束花忘在出租车里，空手站到对方面前，憋了半天只憋出一句“我今天其实带东西了”。",
    emoji: "🌹",
  },
  {
    tag: "口误翻车",
    tagColor: "bg-orange-100 text-orange-700",
    title: "“我能认识你吗”说成“我能认识你妈吗”",
    story:
      "紧张到舌头打结，好好的开场白被说变味，围观群众憋笑到岔气，当事人恨不得原地消失。",
    emoji: "🗣️",
  },
  {
    tag: "后续翻车",
    tagColor: "bg-rose-100 text-rose-700",
    title: "要到了微信却发错人",
    story:
      "终于顺利加上微信，回家打字表白时手滑发给了相亲群，一小时后，整个家族群都开始关心他。",
    emoji: "📱",
  },
];

const EMO = ["🔥", "😂", "😭", "👍", "🙄"];

export default function Awkward() {
  const [liked, setLiked] = useState<number[]>([]);
  const [counts, setCounts] = useState([2841, 1903, 3320, 1287, 4512, 2098]);
  const [selEmo, setSelEmo] = useState<Record<number, string>>({});

  const toggleLike = (i: number) => {
    const on = liked.includes(i);
    setLiked(on ? liked.filter((x) => x !== i) : [...liked, i]);
    setCounts((c) => c.map((v, idx) => (idx === i ? (on ? v - 1 : v + 1) : v)));
  };

  return (
    <section id="awkward" className="bg-orange-50/60 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mb-8 md:mb-10">
          <p className="mb-2 inline-flex items-center gap-2 rounded-full bg-rose-500 px-3 py-1 text-xs font-semibold text-white">
            <i className="ri-error-warning-fill" /> 高能预警
          </p>
          <h2 className="font-hand text-3xl text-stone-900 md:text-4xl">搭讪尴尬瞬间小剧场</h2>
          <p className="mt-2 max-w-2xl text-sm text-stone-500 md:text-base">
            翻车各有各的花样，尴尬从不重样。点开一条条小剧场，看看你有没有“隔着屏幕脚趾抠地”。
          </p>
        </div>

        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {DATA.map((d, i) => (
            <article
              key={d.title}
              className="flex flex-col rounded-2xl border border-stone-200 bg-white p-5 transition-shadow hover:shadow-md md:p-6"
            >
              <div className="flex items-center justify-between">
                <span className={`whitespace-nowrap rounded-full px-3 py-1 text-xs font-semibold ${d.tagColor}`}>
                  {d.tag}
                </span>
                <span className="text-2xl" aria-hidden="true">
                  {d.emoji}
                </span>
              </div>
              <h3 className="mt-4 text-base font-semibold text-stone-900">{d.title}</h3>
              <p className="mt-2 flex-1 text-sm leading-relaxed text-stone-500">{d.story}</p>

              <div className="mt-5 flex items-center justify-between border-t border-stone-100 pt-4">
                <div className="flex items-center gap-1">
                  {EMO.map((e) => (
                    <button
                      key={e}
                      onClick={() => setSelEmo((s) => ({ ...s, [i]: e }))}
                      aria-label={`表情反应${e}`}
                      className={`grid h-8 w-8 place-items-center rounded-full text-base transition-colors ${
                        selEmo[i] === e ? "bg-orange-100" : "hover:bg-orange-50"
                      }`}
                    >
                      {e}
                    </button>
                  ))}
                </div>
                <button
                  onClick={() => toggleLike(i)}
                  aria-label="点赞"
                  className={`inline-flex items-center gap-1 text-xs font-semibold transition-colors ${
                    liked.includes(i) ? "text-orange-500" : "text-stone-400 hover:text-orange-500"
                  }`}
                >
                  <i className={`${liked.includes(i) ? "ri-thumb-up-fill" : "ri-thumb-up-line"} text-base`} />
                  {counts[i].toLocaleString()}
                </button>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}